import { Component, ViewChild, ElementRef, ViewContainerRef, TemplateRef } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { Directive, HostListener } from '@angular/core';
import { Agency_BrachTreeViewProperties } from '../Models/Agency_BrachTreeViewProperties';
import { Agency_BrachTreeViewService } from "../Services/Agency_BrachTreeView.service";
import { Router } from '@angular/router';
declare var $;

@Component({
  selector: 'app-agency-branch-chart',
  templateUrl: './agency-branch-chart.component.html',
  styleUrls: ['./agency-branch-chart.component.css'],
  providers: [Overlay]
})
/** AgencyBranchChart component*/
export class AgencyBranchChartComponent {
  /** AgencyBranchChart ctor */

  //@HostListener('contextmenu', ['$event'])
  //onRightClick(event) {
  //  event.preventDefault();
  //}
  constructor(public overlay: Overlay, public viewContainerRef: ViewContainerRef, private treeService: Agency_BrachTreeViewService, private router: Router) {
  }
  overlayRef: OverlayRef;
  @ViewChild('userMenu', { static: false }) userMenu: TemplateRef<any>;

  treeData: Agency_BrachTreeViewProperties[] = [];
  data1: TreeNode[];
  selectedValue = "";
  parent;
  emptyStr: boolean = false;
  ngOnInit() {
    this.loadTreeData();
  }

  loadTreeData() {
    try {
      /*localStorage.setItem("AgencyId", "AG01")*/
      let agencyId = ""
      if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("AgencyId") != "")) {
        agencyId = (localStorage.getItem("AgencyId"));
        this.treeService.GetAgency_BranchTreeView(agencyId).subscribe((data) => {
          this.treeData = (data);
        });
      }
    }
    catch (e) {
    }
  }


  nodes: any = [
    {
      name: 'OK Travels',
      cssClass: 'main-node',
      childs: [
        {
          name: 'Branches ',
          cssClass: 'branch-main',
          childs: [
            {
              name: 'Branch 1',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 2',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 3',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 4',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
            {
              name: 'Branch 5',
              cssClass: 'child-branch',
              childs: []
            },
          ]
        },
        {
          name: 'Agencies',
          cssClass: 'agency-main',

          childs: [
            {
              name: 'Agency 1',
              cssClass: 'child-agency',
              childs: [
                {
                  name: 'sub_Branch 1',
                  cssClass: 'child-agency',
                  childs: []
                },
                {
                  name: 'sub_Branch 2',
                  cssClass: 'child-agency',
                  childs: []
                },
                {
                  name: 'sub_Agency 1',
                  cssClass: 'child-agency',
                  childs: []
                },
                {
                  name: 'sub_Agency 2',
                  cssClass: 'child-agency',
                  childs: []
                },


              ]
            },
            {
              name: 'Agency 2',
              cssClass: 'child-agency',
              childs: [
                {
                  name: 'sub_Branch 1',
                  cssClass: 'child-agency',
                  childs: []
                },
                {
                  name: 'sub_Branch 2',
                  cssClass: 'child-agency',
                  childs: []
                },
                {
                  name: 'sub_Agency 1',
                  cssClass: 'child-agency',
                  childs: []
                },
                {
                  name: 'sub_Agency 2',
                  cssClass: 'child-agency',
                  childs: []
                },


              ]
            },
            {
              name: 'Agency 3',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 4',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
            {
              name: 'Agency 5',
              cssClass: 'child-agency',
              childs: []
            },
          ]
        },

      ]
    },
  ]

  //ShowOverlay(e) {
  //  try {
  //    this.parent = "";
  //    this.selectedValue = e.code;
  //    if (this.selectedValue.includes("B"))
  //      this.parent = e.parent;
  //    if (this.overlayRef != undefined)
  //      this.overlayRef.dispose();
  //    /*let rect = e.target.getBoundingClientRect();*/
  //    const positionStrategy = this.overlay.position()
  //      .global()
  //    //.centerHorizontally()
  //    //.centerVertically();
  //    //.flexibleConnectedTo({ x, y })
  //    //.withpositions([
  //    //  {
  //    //    originx: 'end',
  //    //    originy: 'bottom',
  //    //    overlayx: 'end',
  //    //    overlayy: 'top',
  //    //  }
  //    //]);
  //    this.overlayRef = this.overlay.create({
  //      hasBackdrop: true,
  //      positionStrategy: positionStrategy,
  //      width: '142px',
  //      height: '139px',
  //      scrollStrategy: this.overlay.scrollStrategies.close(),
  //    });
  //    this.overlayRef.attach(new TemplatePortal(this.userMenu, this.viewContainerRef));
  //    this.overlayRef.backdropClick().subscribe(() => this.overlayRef.dispose());
  //    ////console.log (positionStrategy);
  //  }
  //  catch (e) {
  //    ////console.log (e)
  //  }
  //}

  InActiveAgency_Branch() {
    try {
      let isAgency;
      if (this.selectedValue != "" && this.selectedValue != null) {
        if (this.selectedValue.includes("B"))
          isAgency = false;
        else
          isAgency = true;
        this.treeService.InActiveAgency_Branch(this.selectedValue, isAgency).subscribe((data) => {
          if (data == true)
            this.loadTreeData();
        });
      }
    }
    catch (e) {

    }
  }
  ShowOverlay(e) {
    try {
      ////console.log (e);
      this.parent = "";
      this.selectedValue = e.code;
      if (this.selectedValue.includes("B"))
        this.parent = e.parent;
      if (this.overlayRef != undefined)
        this.overlayRef.dispose();
      /*let rect = e.target.getBoundingClientRect();*/
      const positionStrategy = this.overlay.position()
        .global()
      //.centerHorizontally()
      //.centerVertically();
      //.flexibleConnectedTo({ x, y })
      //.withpositions([
      //  {
      //    originx: 'end',
      //    originy: 'bottom',
      //    overlayx: 'end',
      //    overlayy: 'top',
      //  }
      //]);
      this.overlayRef = this.overlay.create({
        hasBackdrop: true,
        positionStrategy: positionStrategy,
        width: '142px',
        height: '139px',
        scrollStrategy: this.overlay.scrollStrategies.close(),
      });
      this.overlayRef.attach(new TemplatePortal(this.userMenu, this.viewContainerRef));
      this.overlayRef.backdropClick().subscribe(() => this.overlayRef.dispose());
      if (e.code == "AG01" || e.parent == "" || e.immediateParent == "" || e.cssClass == "main-node") {
        this.emptyStr = false;
      }
      else {
        this.emptyStr = true;
      }
    }
    catch (e) {
      ////console.log (e)
    }
  }

  onMouseClick(e: MouseEvent) {
    ////console.log (e.target);
    //e.pageX will give you offset from left screen border
    //e.pageY will give you offset from top screen border

    //determine popup X and Y position to ensure it is not clipped by screen borders
    const popupHeight = 400, // hardcode these values
      popupWidth = 300;    // or compute them dynamically

    let popupXPosition,
      popupYPosition

    if (e.clientX + popupWidth > window.innerWidth) {
      popupXPosition = e.pageX - popupWidth;
    } else {
      popupXPosition = e.pageX;
    }

    if (e.clientY + popupHeight > window.innerHeight) {
      popupYPosition = e.pageY - popupHeight;
    } else {
      popupYPosition = e.pageY;
    }
  }

  NewAgency() {
    if (this.selectedValue != "" && this.selectedValue != null) {
      localStorage.setItem("TreeSelectedValue", this.selectedValue);
      localStorage.setItem("TreeBranchParent", this.parent);
      this.overlayRef.dispose();
      this.router.navigateByUrl("/agencyMaster");
    }
  }

  NewBranch() {
    if (this.selectedValue != "" && this.selectedValue != null) {
      localStorage.setItem("Branch_TreeSelectedValue", this.selectedValue);
      localStorage.setItem("Branch_TreeBranchParent", this.parent);
      this.overlayRef.dispose();
      this.router.navigateByUrl("/branchInformation");
    }
  }

  ConfigureAgency_Branch() {
    try {
      if (this.selectedValue != "" && this.selectedValue != null) {
        if (this.selectedValue.includes("B")) {
          localStorage.setItem("BranchListId", this.selectedValue)
          this.router.navigateByUrl("/branchInformation");
        }
        else {
          localStorage.setItem("AgencyListId", this.selectedValue)
          this.router.navigateByUrl("/agencyMaster");
        }
      }
    }
    catch (e) {

    }
  }
  DeleteAgency_Branch() {
    try {
      let isAgency;
      if (this.selectedValue != "" && this.selectedValue != null) {
        if (this.selectedValue.includes("B"))
          isAgency = false;
        else
          isAgency = true;
        this.treeService.DeleteAgency_Branch(this.selectedValue, isAgency).subscribe((data) => {
          if (data == true)
            this.loadTreeData();
        });
      }
    }
    catch (e) {

    }
  }
}
